import r from "../../_styles/common/light.js";
function a(e) {
  const {
    opacityDisabled: t,
    heightTiny: o,
    heightSmall: n,
    heightMedium: g,
    heightLarge: h,
    heightHuge: s,
    primaryColor: i,
    fontSize: m
  } = e;
  return {
    fontSize: m,
    textColor: i,
    sizeTiny: o,
    sizeSmall: n,
    sizeMedium: g,
    sizeLarge: h,
    sizeHuge: s,
    color: i,
    opacitySpinning: t
  };
}
const l = {
  name: "Spin",
  common: r,
  self: a
}, p = l;
export {
  p as default,
  a as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/spin/styles/light.js
// module id = 1699
// module chunks = 41